import type { BasicLineSeriesSettings, SeriesSettings } from "../../../../../../../../../api/types/svTypes.ts";

export function getShowPoints(serie: SeriesSettings | undefined) {
  const linearSerie = serie as BasicLineSeriesSettings;
  return linearSerie?.showPoints === true;
}
